export interface INextgenApplicationModel {
  name: string;
  description: string;
  icon: { attachment: string };
  displayName: string;
  iconUrl: string;
  url: string;
  isExternal: boolean;
  showInMenu: boolean;
  active: boolean;
  smallIcon: string;
  productType: string;
}

export class NextgenApplicationModel implements INextgenApplicationModel {
  name = '';
  description = '';
  icon = { attachment: '' };
  displayName = '';
  iconUrl = '';
  url = '';
  isExternal = false;
  showInMenu = false;
  active = false;
  smallIcon = '';
  productType = '';

  constructor(name: string, description: string) {
    this.name = name;
    this.description = description;
  }
}
